import { LineItem } from '@schuettflix/summary';
import { usePlatformOrganizationId } from '@/clients/platformInfo/usePlatformInfo.ts';
import { useTranslation } from 'react-i18next';
import { SUPPORTED_UNIT_LABEL } from '@/phrase/SupportedUnitLabels.ts';
import { useFormatters } from '@/shared/hooks/useFormatters/useFormatters.ts';
import { cn } from '@/shared/utils/cn.ts';

type FinanceSettingsLineItemsProps = {
    lineItems: LineItem[];
};

export function FinanceSettingsLineItems({ lineItems }: FinanceSettingsLineItemsProps) {
    const platformOrganizationId = usePlatformOrganizationId();
    const { formatNumberWithCurrency, formatNumberWithCurrencyPerUnit, formatNumber } = useFormatters();
    const { t } = useTranslation();

    return (
        <table className="font-copy-md w-full">
            <tbody>
                {lineItems.map((summaryLineItem, index) => {
                    const isRevenueIncreasing = summaryLineItem.creditorOrganizationId === platformOrganizationId;
                    return (
                        <tr key={index} className="-mx-1">
                            <td className="min-w-[5.5rem] whitespace-nowrap py-1 pr-1">
                                {`${formatNumber(summaryLineItem.quantity)} ${t(SUPPORTED_UNIT_LABEL[summaryLineItem.unit])}`}
                            </td>
                            <td className="w-full max-w-0 truncate px-1 py-1">{summaryLineItem.productName}</td>
                            <td className="min-w-[6.5rem] whitespace-nowrap px-1 py-1 text-right">
                                {formatNumberWithCurrencyPerUnit(summaryLineItem.unitPriceAmount, summaryLineItem.unit)}
                            </td>
                            <td
                                className={cn('min-w-[6.5rem] whitespace-nowrap py-1 pl-1 text-right', {
                                    'text-success': isRevenueIncreasing,
                                    'text-critical': !isRevenueIncreasing,
                                })}
                            >
                                {formatNumberWithCurrency(summaryLineItem.amountNet)}
                            </td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );
}
